<template>
    <div class="large-container">
        <form class="login-form" @submit.prevent="ForgotPassword($event)" >
            <h2 class="left">Porfavor introduzca su correo electrónico para comenzar con el flujo de recuperación</h2>
            <input type="text" class="form-control left" required name="email"  id="email" placeholder="Correo electrónico">
            <div class="large-container">
                <input class="ui green button wide" type="submit" value="Enviar email de recuperación" >
            </div>
            <br><br>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    methods:{
        ...mapActions(['ForgotPassword'])
    }
}
</script>